export default __webpack_public_path__ + "static/media/hht2_ep13_book_wp_02.0923eb84.jpg";